import Insight from './Insight'

export default Insight
